import { createSlice } from '@reduxjs/toolkit'

export const processLogs = createSlice({
    name: 'processLogs',
    initialState: {
        pid: '',
        status: '',
        entries: [],
    },
    reducers: {
        setLogPid: (state, action) => {
            state.pid = action.payload;
        },
        setLogStatus: (state, action) => {
            state.status = action.payload;
        },
        setLogEntries: (state,action) => {
            state.entries = action.payload;
        },
        appendLogEntries: (state,action) => {
            state.entries = state.entries.concat(action.payload);
        },
    },
});

export const { setLogPid, setLogStatus, setLogEntries, appendLogEntries } = processLogs.actions;


export const process = createSlice({
    name: 'process',
    initialState: {
        loadingViewer: {value: false},
        draftStarted: {value: false},
    },
    reducers: {
        setLoadingViewer: (state, action) => {
            state.loadingViewer = action.payload;
        },
        setDraftStarted: (state, action) => {
            state.draftStarted = action.payload;
        },
    },
});


export const { setLoadingViewer, setDraftStarted } = process.actions;